import React from "react"
import moment from "moment"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import MenuList from "@material-ui/core/MenuList"
import MenuItem from "@material-ui/core/MenuItem"
import Typography from "@material-ui/core/Typography"
import Divider from "@material-ui/core/Divider"
import Container from "@material-ui/core/Container"
import Link from "@material-ui/core/Link"

import { makeStyles } from "@material-ui/core/styles"

import PhotoOutlinedIcon from "@material-ui/icons/PhotoOutlined"
import TouchAppOutlinedIcon from "@material-ui/icons/TouchAppOutlined"
import SaveAltIcon from "@material-ui/icons/SaveAlt"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid"

import InstallAppDialog from "./InstallAppDialog"

import useDefaultStyles from "../../../styles/default"

import { useHomeState } from "../../../store/home"

import { Cover, AboutGallery, Header } from "./styles"

import no_cover_placeholder from "../../../assets/no_cover_placeholder.png"

import { useNavigation } from "../../../services/navigation"

const useStyles = makeStyles(() => ({
	menuItem: {
		height: "60px",
		textDecoration: "none !important",
		"&:hover": {
			textDecoration: "none !important"
		}
	},
	menuBox: {
		boxShadow: "0px 0px 10px #EEE",
		borderRadius: "5px",
		margin: "0px 0px 20px"
	},
	menuList: {
		padding: "0px"
	},
	container: {
		width: "100%",
		backgroundColor: "#FFF",
		padding: 0
	}
}))

const Home = () => {
	const { navigate, getRouteParams } = useNavigation()

	const { hash } = getRouteParams()

	const homeState = useHomeState()

	const classes = useStyles()
	const defaultClasses = useDefaultStyles()

	return (
		<Container className={classes.container}>
			{window.innerWidth < 960 && (
				<Cover
					src={homeState.gallery.cover || no_cover_placeholder}
					alt="cover"
				/>
			)}

			<Divider className={defaultClasses.invisibleDividerLarge} />

			<AboutGallery>
				<Header>
					<Typography variant="h6" style={{ lineHeight: "16px" }}>{homeState.gallery.title}</Typography>

					<Typography variant="subtitle1" style={{ fontSize: 14 }}>
						{homeState.gallery.event_date &&
							`${moment(homeState.gallery.event_date).format("L")} | `}
						{homeState.gallery.info &&
							homeState.gallery.info.total_pictures !== undefined &&
							`${homeState.gallery.info.total_pictures} ${
								homeState.gallery.info.total_pictures === 1 ? "FOTO" : "FOTOS"
							}`}
					</Typography>
				</Header>

				<Divider className={defaultClasses.invisibleDividerLarge} />

				<MenuList className={classes.menuList}>
					<Divider light />
					{homeState.front.selection_url && (
						<>
							<MenuItem
								className={classes.menuItem}
								component={Link}
								href={homeState.front.selection_url}
								target="_self"
							>
								<ListItemIcon>
									<TouchAppOutlinedIcon style={{ fontSize: 30 }} />
								</ListItemIcon>
								<Typography variant="button">ESCOLHER FOTOS</Typography>
								<ListItemIcon style={{ marginLeft: "auto", minWidth: "auto" }}>
									<ArrowForwardIosIcon fontSize="small" />
								</ListItemIcon>
							</MenuItem>

							<Divider light />
						</>
					)}

					{// If user is not logged in but the selection is activated, when he clicks here
					// it will open a modal requiring him to log in or sign up
					!homeState.front.selection_url &&
						homeState.front.selection_activated &&
						!homeState.client && (
							<>
								<MenuItem
									className={classes.menuItem}
									onClick={() => navigate(`/${hash}/${homeState.front.sel_link_type === "private" ? "login" : "signup"}?callback=select_mode`,
										{ keepQueryParams: true }
									)}
								>
									<ListItemIcon>
										<TouchAppOutlinedIcon style={{ fontSize: 30 }} />
									</ListItemIcon>
									<Typography variant="button">ESCOLHER FOTOS</Typography>
									<ListItemIcon
										style={{ marginLeft: "auto", minWidth: "auto" }}
									>
										<ArrowForwardIosIcon fontSize="small" />
									</ListItemIcon>
								</MenuItem>

								<Divider light />
							</>
						)}

					{homeState.front.gallery_url && (
						<MenuItem
							className={classes.menuItem}
							component={Link}
							href={homeState.front.gallery_url}
							target="_self"
						>
							<ListItemIcon>
								<PhotoOutlinedIcon style={{ fontSize: 30 }} />
							</ListItemIcon>
							<Typography variant="button">VER FOTOS</Typography>
							<ListItemIcon style={{ marginLeft: "auto", minWidth: "auto" }}>
								<ArrowForwardIosIcon fontSize="small" />
							</ListItemIcon>
						</MenuItem>
					)}

					{homeState.front.download_all && (
						<>
							<Divider light />

							<MenuItem
								className={classes.menuItem}
								onClick={() => navigate(`/${hash}/download`)}
							>
								<ListItemIcon>
									<SaveAltIcon style={{ fontSize: 30 }} />
								</ListItemIcon>
								<Typography variant="button">DOWNLOAD</Typography>
								<ListItemIcon style={{ marginLeft: "auto", minWidth: "auto" }}>
									<ArrowForwardIosIcon fontSize="small" />
								</ListItemIcon>
							</MenuItem>
						</>
					)}

					<Divider light />

					<InstallAppDialog>
						<MenuItem className={classes.menuItem}>
							<ListItemIcon>
								<PhoneAndroidIcon style={{ fontSize: 30 }} />
							</ListItemIcon>
							<Typography variant="button">SALVAR COMO APLICATIVO</Typography>
							<ListItemIcon style={{ marginLeft: "auto", minWidth: "auto" }}>
								<ArrowForwardIosIcon fontSize="small" />
							</ListItemIcon>
						</MenuItem>
					</InstallAppDialog>

					<Divider light />
				</MenuList>
			</AboutGallery>
		</Container>
	)
}

export default Home
